import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberCybercover = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "currentColor",
	viewBox: "0 0 64 64",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M32 8.65a1 1 0 0 1 .717.303A23.6 23.6 0 0 0 49.87 16.1a1 1 0 0 1 1.008.942l-.998.058.998-.057v.006l.002.018.003.064.01.239c.006.208.014.51.016.897.005.773-.01 1.883-.09 3.247-.159 2.724-.577 6.469-1.616 10.551-2.074 8.148-6.657 17.775-16.73 23.176a1 1 0 0 1-.946 0C21.46 49.84 16.875 40.213 14.801 32.066c-1.04-4.083-1.46-7.828-1.62-10.552a51 51 0 0 1-.09-3.247 33 33 0 0 1 .026-1.136l.003-.064.001-.017v-.007l.999.057-.998-.058a1 1 0 0 1 1.008-.942 23.56 23.56 0 0 0 17.153-7.147 1 1 0 0 1 .716-.303m-16.907 9.441-.002.188c-.005.735.01 1.802.087 3.117.155 2.633.56 6.247 1.561 10.176C18.71 39.314 22.954 48.146 32 53.219c9.051-5.074 13.295-13.905 15.265-21.647 1-3.929 1.404-7.543 1.558-10.175a48 48 0 0 0 .085-3.306A25.6 25.6 0 0 1 32 11.056a25.56 25.56 0 0 1-16.908 7.035",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M42.397 25.333a1 1 0 0 1 0 1.414l-10.43 10.43a1 1 0 0 1-1.414 0l-5.22-5.22a1 1 0 0 1 1.414-1.414l4.513 4.513 9.723-9.723a1 1 0 0 1 1.414 0M58.1 3.17a2.46 2.46 0 1 0 0 4.92 2.46 2.46 0 0 0 0-4.92m-4.46 2.46a4.46 4.46 0 1 1 8.92 0 4.46 4.46 0 0 1-8.92 0M58.1 29.26a2.46 2.46 0 1 0 0 4.92 2.46 2.46 0 0 0 0-4.92m-4.46 2.46a4.46 4.46 0 1 1 8.92 0 4.46 4.46 0 0 1-8.92 0M58.1 55.35a2.46 2.46 0 1 0 0 4.92 2.46 2.46 0 0 0 0-4.92m-4.46 2.46a4.46 4.46 0 1 1 8.92 0 4.46 4.46 0 0 1-8.92 0",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M48.19 30.72h6.45v2h-6.45zM44.714 5.623a1 1 0 0 1 .856-.483h9.07v2h-8.506l-5.168 8.547-1.712-1.034zM45.525 58.328l-6.1-10.08 1.71-1.036 5.809 9.598h8.516v2h-9.08a1 1 0 0 1-.855-.482M5.97 3.02a2.46 2.46 0 1 0 0 4.92 2.46 2.46 0 0 0 0-4.92M1.51 5.48a4.46 4.46 0 1 1 8.92 0 4.46 4.46 0 0 1-8.92 0M5.97 29.11a2.46 2.46 0 1 0 0 4.92 2.46 2.46 0 0 0 0-4.92m-4.46 2.46a4.46 4.46 0 1 1 8.92 0 4.46 4.46 0 0 1-8.92 0M5.97 55.2a2.46 2.46 0 1 0 0 4.92 2.46 2.46 0 0 0 0-4.92m-4.46 2.46a4.46 4.46 0 1 1 8.92 0 4.46 4.46 0 0 1-8.92 0",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M15.88 32.57H9.43v-2h6.45zM9.43 4.99h9.07a1 1 0 0 1 .856.483l5.46 9.03-1.712 1.034-5.168-8.547H9.43zM17.126 56.66l5.808-9.598 1.711 1.036-6.1 10.08a1 1 0 0 1-.855.482H8.61v-2z",
			clipRule: "evenodd"
		})
	]
});
export default SvgCyberCybercover;
